import React, { useEffect, useRef, useState } from "react";
import bgImage from "../../assets/Images/Splash_Page_Music.png";
const Login = () => {
 

  return (
 <div
  className="newblock_comingsoon"
    
    role="main"
    aria-label="    Comingsoon Page"
    >
    <div className="imageContainer" 
        style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            minHeight: '150vh',
            width: '100%',
            backgroundRepeat: 'no-repeat',
        }}>

        </div>
  
</div>
  );
};

export default Login;
